<template>
  <div class="w-100">
    {{ $lodash.get(activity, "detail.appointments.ids.length") }} Recurring Appointments added:

    <user-object
      :entity-id="appointmentTechnicianId()"
      :name="$lodash.get(activity, 'detail.appointments.user.name')"
      :open-new="true"
    />
    at {{ $lodash.get(activity, "detail.appointments.time") }} for
    {{ $lodash.get(activity, "detail.appointments.duration") }}
    {{ $lodash.get(activity, "detail.appointments.duration") === 1 ? "hour" : "hours" }}

    <div>
      <a
        v-tooltip="{
          content: $lodash.get(activity, 'detail.rule'),
          classes: 'badge-theme',
        }"
        class="badge badge-large badge-info"
      >
        Recurring Definition
      </a>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
